import { initializeApp } from 'firebase/app';
import { Capacitor } from "@capacitor/core";
import { getMessaging, isSupported, Messaging } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDOMYdFrzzeYHTBXFLXCGVGjhmBhe_F0yo",
  authDomain: "kis-portal-c71cc.firebaseapp.com",
  projectId: "kis-portal-c71cc",
  storageBucket: "kis-portal-c71cc.firebasestorage.app",
  messagingSenderId: "564565988489",
  appId: "1:564565988489:web:5d3e656aedcf2160e8a258",
  measurementId: "G-84BPP84MZ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();


export { auth, provider, messaging };

export const initFirebaseMessaging = async () => {
  if (messaging) return messaging;

  const supported = await isSupported();
  if (supported) {
    messaging = getMessaging(app);
    console.log("Firebase Messaging initialized for web.");
    return messaging;
  } else {
    return null;
  }
};

export const getFirebaseMessaging = () => messaging;